'use strict'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import MergeDropdownComponent from '../commonComponents/MergeDropdownComponent';
import LoadingComponent from '../commonComponents/LoadingComponent';
import CallAPI from '../commonComponents/AxiosHelper';
import { connect } from 'react-redux';
import TableTags from './TableTags';
import ErrorComponent from '../commonComponents/ErrorComponent';

class StepOne extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            rawTables: null,
            selectedTable: {
                "transaction": [],
                "master": []
            },
            count:null
        }
        this.getTableData = this.getTableData.bind(this);
        // this.fetchTableData = this.fetchTableData.bind(this);
        this.nextAction = this.nextAction.bind(this);
        this.getSelectedTable = this.getSelectedTable.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);

    }

    componentWillMount(){
        // if (this.props.stepData.props.tableData == null || this.props.stepData.props.tableData == undefined){
            this.getTableData();
        // }
    }

    componentDidMount(){
        // if (this.props.stepData.props.tableData !== null && this.props.stepData.props.tableData !== undefined) {
        // }
    }

 
    handleTableChange(e,reference){
        let selectedTable = jQuery(`#${e.target.id}`).val();
        // jQuery(`#${e.target.id}`).selectpicker('val', selectedTable);
        if(!(Array.isArray(selectedTable))){
            selectedTable = [selectedTable]
        }
        let tableArray = {};


        let params = {
            "selectedTable": selectedTable,
            "data": reference.props.dropdownConfig.dropdownData
        };

        tableArray = this.getSelectedTable(params);

        let parameters = {
            "type": reference.props.type,
            "tableArray": tableArray
        }

        let current_state = this.state.selectedTable;
        current_state[parameters['type']] = parameters['tableArray'];

        this.setState({
            selectedTable:current_state
        }) 
        this.props.stepData.handleSelectedTables(parameters);
    }

    getTableData(params = null) {
        let data = (this.props.stepData.props.tableData == null || this.props.stepData.props.tableData == undefined) ? this.state.rawTables : this.props.stepData.props.tableData ;

        // data = (params !== null && params !== undefined) ?params:data;

        data = data ? data : []
        let transactionArray = [];
        let masterArray = [];

        data.map((element, i) => {
            element['value'] = element['targetTableName'];
            element['name'] = element['virtualTableName'];
            if ((element['type'] !== null && element['type'] !== undefined) && ((element['type']).toLowerCase() == "master" )) {
                masterArray.push(element);   
            }
            // if ((element['type'] !== null && element['type'] !== undefined) && ((element['type']).toLowerCase() == "master" || element['type'].toLowerCase() == "merge")) {
            //     masterArray.push(element);
            // }
            if ((element['type'] !== null && element['type'] !== undefined) && ((element['type']).toLowerCase() == "transaction" || element['type'].toLowerCase() == "merge")) {
                transactionArray.push(element);
            }
        });

        let refinedData = { "transaction": transactionArray, "master": masterArray };
        this.props.stepData.state.selectedTable = {
            "transaction": [],
            "master": []
        }
        this.setState({
            data: refinedData,
        })
    }


    getSelectedTable(params){
        let selectedTableArray = []
        let tableArray = params["selectedTable"];
        let data = params["data"];

        tableArray.forEach((element,i) => {
            let filteredValue = data.filter((innerData,j)=>{
                return element == innerData.value;
            })
            selectedTableArray.push(filteredValue[0]);
        });
        return selectedTableArray;
    }

    nextAction(e){
        if(e.target.id == "selectTableButton"){
            if (this.state.selectedTable['transaction'].length == 0 ) {
            // || this.state.selectedTable['master'].length == 0 ){
                alert("Please Select a Transaction and Master Tables to complete this step!");
            }
            else{
                this.props.stepData.handleSteps(this);
            }
        }
    }



    render() {

        let transaction_array = {
            "class": "my-1",
            "id": "transaction_table",
            "placeholder": "Select transaction table",
            "size": 5,
            "value": this.state.selectedTable['transaction'],
            "dropdownData": this.state.data['transaction'],
            "multi": true,
            "valueFlag":false

        };

        let master_array = {
            "class": "my-1",
            "id": "master_table",
            "placeholder": "Select master table",
            "size": 5,
            "value": this.state.selectedTable['master'],
            "dropdownData": this.state.data['master'],
            "multi": true,
            "valueFlag": false

        };


        return (
            <>
                <div className="card">
                    <div className="card-body" >
                        <form name={"tableInfo"} id={"tableInfo"} autoComplete={"off"} style={{ maxWidth: "350px" }}>
                            <div className="d-flex">
                                <div className="align-items-start mg-b-10">
                                    <span className="tx-spacing-1">Select transaction tables*</span>
                                    <MergeDropdownComponent dropdownConfig={transaction_array} type="transaction" onChange={this.handleTableChange} />
                                </div>
                            </div>

                            <div className="d-flex">
                                <div className="align-items-start mg-b-10">
                                    <span className="tx-spacing-1">Select master tables</span>
                                    <MergeDropdownComponent dropdownConfig={master_array} type="master" onChange={this.handleTableChange} />
                                    <div className="mg-t-2 w-100">
                                        <button type="button" id="selectTableButton" onClick={this.nextAction} className="btn btn-sm btn-primary w-100">Next</button>
                                    </div>
                                </div>
                            </div>                        
                        </form>
                    </div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return { tableData: state.admin.tableData };

}


// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({
//         setToolId
//     }, dispatch)
// }

export default connect(mapStateToProps, null)(StepOne);
// export default DataMerge;

